<!--<div>
  <iframe src='http://noatdc-dweb911:6083/ImportExportFile.aspx' height="800" width="100%"></iframe>-->
  <!--<iframe src='https://localhost:44339/ImportExportFile.aspx' height="800" width="100%"></iframe>-->
<!--</div>-->


<div>
  <!--<iframe src='http://noatdc-dweb911:6083/ImportExportFile.aspx?userName=biswas' height="800" width="100%"></iframe>-->
  <iframe [src]="url" height="800" width="100%"></iframe>
</div>
